export default __webpack_public_path__ + "static/media/me_active_w.78e10b98.svg";